import axios from "../../../axios";

export const pageTitle = {
    en: "My Hostings",
    ru: "Мои хостинги",
    am: "Իմ հոսթինգները",
};

export const hostingDetailBtn = {
    en: "Detail",
    ru: "Деталь",
    am: "Մանրամասն",
}

export const getHostingsAccounts = async () => {
    try {
        const user_id = localStorage.getItem("user_id");
        const customer_id = localStorage.getItem("reseller_customer_id");

        const response = await axios.get(`isp/get_isp_manager_details`, {
            params: {
                user_id, customer_id, username: 'PoghosKeshishyan'
            }
        });

        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getHostingAccountById = async (id) => {
    try {
        const user_id = localStorage.getItem("user_id");

        const response = await axios.get(`isp/get_isp_manager_details_by_id`, {
            params: {
                user_id, isp_id: id,
            }
        });

        if (response.status !== 200) {
            throw new Error("Error in fetching ISP manager detail");
        }

        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const getSingleHostingPageData = async (lang) => {
    const res = await axios.get('hosting/single_hosting_page?lang='+lang);
    return res.data[0];
};